import React from 'react'
import OLXLogo from '../components/OLXLogo'

class Footer extends React.Component {
  render() {
    return (
      <section id="footer">
        <a href="https://www.olxgroup.com" target="_blank"><OLXLogo /></a>
      </section>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js